import React, { Component } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  Button,
} from "design-react-kit";
import {
  adminService,
  dateHelper,
  networkErrorHelper,
  qrCodeService,
} from "libs";
import QrReader from "react-qr-reader";
import { withRouter } from "react-router-dom";
import { Title } from "components/misc";
import { NavLink } from "react-router-dom/cjs/react-router-dom";
import { ROUTES } from "const";
import { getCurrentRegion } from "store/actions";

class QrCodeReader extends Component {

  state = {
    showScanner: true,
    result: "",
    lessonInfo: null,
    continuousScan: false,
    isLoading: false,
    collapseOpen1: false,
    collapseOpen2: false,
    idLesson: 0,
    lessonType: this.props.lessonType || "",
    allowUserLesson: true,
    allLocationKeys: [],
    currentRegion: "",
  };

  componentDidMount() {

    const currentRegion = getCurrentRegion();
    if (currentRegion) {
      this.setState({ currentRegion });    
    } else {
      // redirect to dashboard steward
      this.props.history.push(ROUTES.STEWARD_DASHBOARD);
    }

    const { idLesson, lessonType } = this.props.match.params;
    this.setState({ idLesson, lessonType });

    this.loadremote(idLesson);
  }

  loadremote = (idLesson) => {
    this.setState({ loading: true });
    const searchFilter = {
      id: parseInt(idLesson),
    };

    let api = null;
    if (this.state.lessonType === "lessonOnSite") {
      api = adminService.loadLessonOnSiteSchedule({ searchFilter });
    } else if (this.state.lessonType === "lessonTraining") {
      api = adminService.loadTrainingSchedule({ searchFilter });
    } else {
      console.error("Invalid lesson type:", this.state.lessonType);
      this.setState({ loading: false });
      return;
    }

    api
      .then(({ data }) => {
        let lessonInfo;
        let allLocationKeys = [];

        if (this.state.lessonType === "lessonOnSite") {
          lessonInfo = data.payload.lessonOnSiteSchedule;
        } else {
          lessonInfo = data.payload.trainingSchedule;
        }

        allLocationKeys = data.payload.allLocationKeys || [];

        //--- get course info ---

        this.setState({
          loading: false,
          lessonInfo: lessonInfo,
          allLocationKeys: allLocationKeys,
        });
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
        this.setState({ loading: false });
      });
  };

  autoRescan = (continuousScan, delay = 1000) => {
    if (continuousScan) {
      setTimeout(() => {
        this.newScan();
      }, delay);
    }
  }; //autoRescan

  handleScan = (registrationCode = false) => {
    if (registrationCode) {
      //this.setState({ results: data });
      const startLoading = setTimeout(() => {
        this.setState({ isLoading: true });
      }, 1500);

      //--- get remote info ---
      adminService
        .getDataByQrRegistrationCode(
          registrationCode,
          this.state.idLesson,
          this.state.lessonType,
          this.state.currentRegion
        )
        .then((data) => {
          this.setState({
            showScanner: false,
            isLoading: false,
            result:
              data.data.payload.result.length > 0
                ? data.data.payload.result[0]
                : "",

            allowedAction:
              data.data.payload.allowUserLesson.length > 0 ? true : false,
          });

          this.beep(4, 1500, 125);

          clearTimeout(startLoading);
        })
        .catch((errors) => {
          if (networkErrorHelper.is404(errors)) {
            networkErrorHelper.notify(errors);
          }

          this.beep(8, 250, 250);

          this.setState({ isLoading: false });
          clearTimeout(startLoading);
          /** auto start new scan after */
          //this.autoRescan(this.state.continuousScan, 5000);
        });
    }
  };

  handleError = (err) => {
    this.beep(4, 250, 125);
    console.error(err);
    /** auto start new scan after */
    //this.autoRescan(this.state.continuousScan, 3000);
  };

  newScan = () => {
    this.setState({ showScanner: true, result: "" });
  };

  beep = (vol, freq, duration) => {
    let a = new AudioContext();
    let v = a.createOscillator();
    let u = a.createGain();
    v.connect(u);
    v.frequency.value = freq;
    v.type = "square";
    u.connect(a.destination);
    u.gain.value = vol * 0.01;
    v.start(a.currentTime);
    v.stop(a.currentTime + duration * 0.001);
  }; //beep

  doAction = (idLesson, lessonType, registrationCode, action) => {
    this.setState({ isLoading: true });

    const params = {
      idLesson: idLesson,
      lessonType: lessonType,
      registrationCode: registrationCode,
      action: action,
      region: this.state.currentRegion,
    };

    qrCodeService
      .action(params)
      .then(({ data }) => {
        setTimeout(() => {
          this.setState({ isLoading: false });
          this.newScan();
        }, 250);
      })
      .catch((error) => {
        console.log(error);
        this.setState({ isLoading: false });
        networkErrorHelper.notify(error);
      });
  }; //doAction

  toggle = (id) => {
    this.setState({
      ...this.state,
      [`collapseOpen${id}`]: !this.state[`collapseOpen${id}`],
    });
  };

  //--- ---

  render() {
    const {
      showScanner,
      isLoading,
      result,
      collapseOpen1 /*, collapseOpen2*/,
      idLesson,
      lessonType,
      allowedAction,
      currentRegion,
    } = this.state;

    /*if (isLoading) {
      return <MnemoLoading />;
    }*/

    if (this.state.lessonInfo === null) {
      return false;
    }
    const {
      title = "---",
      courseCode = "---",
      teacher = "---",
      hourStart = "---",
    } = this.state.lessonInfo;

    return (
      <>
        <div>
          <Title>Controllo Presenze: {currentRegion}</Title>
          <div className="subTitleCameraReader">
            {title + " - inizio ore " + hourStart.slice(0, -3)}
          </div>
          <div className="subTitleCameraReader">{teacher}</div>
          <div className="subTitleCameraReader">{courseCode}</div>
        </div>
        {showScanner && (
          <div>

            <QrReader
              delay={400}
              onError={this.handleError}
              onScan={this.handleScan}
              resolution={700}
              className="cameraReader"
            />
            <p className="scanNotes">
              puoi procedere con la scansione di un QrCode valido
            </p>
            <p className="scanNotes">
              <button
                onClick={() => window.history.back()}
                className="btn btn-primary bg-dark mx-1"
              >
                INDIETRO
              </button>
              <NavLink
                to={ROUTES.DASHBOARD_STEWARD}
                className="btn btn-primary bg-dark mx-1"
              >
                DASHBOARD
              </NavLink>
            </p>
          </div>
        )}

        {!showScanner && (
          <div className="userData">
            <hr />
            <h4>VERIFICA DATI</h4>

            {allowedAction === false && (
              <div className="titleCameraReader titleCameraReaderDanger">
                CORSISTA NON ISCRITTO A QUESTA LEZIONE
              </div>
            )}

            {allowedAction === false && (
              <div className="titleCameraReader titleCameraReaderDanger">
                CORSISTA NON ISCRITTO A QUESTA LEZIONE
              </div>
            )}

            <ul className="QrUserData">
              <li>
                Nome e Cognome:{" "}
                <b>
                  {result.name} {result.surname}
                </b>
              </li>
              <li>
                Identificativo: <b>{result.registrationCode}</b>
              </li>
              <li>
                Percorso: <b>{result.title}</b>
              </li>
              <li>
                regione: <b>{result.pluginConfig.region}</b>
              </li>             
            </ul>

            <Accordion>
              <AccordionHeader
                active={collapseOpen1}
                onToggle={() => this.toggle(1)}
              >
                <h4>Dati Anagrafici</h4>
              </AccordionHeader>
              <AccordionBody active={collapseOpen1}>
                <ul className="QrUserData">
                  <li>
                    Data di Nascita: <b>{dateHelper.toITDate(result.dob)}</b>
                  </li>
                  <li>
                    Genere: <b>{result.gender === "m" ? "Uomo" : "Donna"}</b>
                  </li>
                  <li>
                    Email: <b>{result.email}</b>
                  </li>
                  <li>
                    Telefono: <b>{result.mobile}</b>
                  </li>

                  <li className="my-2">
                    <h4>Luogo di Nascita</h4>
                  </li>
                  {!result.isForeign && (
                    <>
                      <li>
                        Comune: <b>{result.city}</b>
                      </li>
                      <li>
                        CAP: <b>{result.cap}</b>
                      </li>
                      <li>
                        Provincia: <b>{result.province}</b>
                      </li>
                      <li>
                        Nazione: <b>{result.nationality}</b>
                      </li>
                    </>
                  )}
                  {result.isForeign && (
                    <>
                      <li>
                        Città estera: <b>{result.cityForeign}</b>
                      </li>
                      <li>
                        ZipCode: <b>{result.cap || result.zip}</b>
                      </li>
                      <li>
                        Nazione: <b>{result.nationality || result.nation}</b>
                      </li>
                      <li>
                        Data di Nascita:{" "}
                        <b>{dateHelper.toITDate(result.dob)}</b>
                      </li>
                    </>
                  )}
                </ul>
              </AccordionBody>
            </Accordion>

            <p className="serviceBtn">
              <Button
                className={
                  isLoading || allowedAction === false
                    ? "loadingBtn"
                    : "checkInBtn"
                }
                disabled={isLoading || allowedAction === false ? true : false}
                onClick={() => {
                  this.doAction(
                    idLesson,
                    lessonType,
                    result.registrationCode,
                    "login"
                  );
                }}
              >
                INGRESSO
              </Button>
              <Button
                className={
                  isLoading || allowedAction === false
                    ? "loadingBtn"
                    : "checkOutBtn"
                }
                disabled={isLoading || allowedAction === false ? true : false}
                onClick={() => {
                  this.doAction(
                    idLesson,
                    lessonType,
                    result.registrationCode,
                    "logout"
                  );
                }}
              >
                USCITA
              </Button>
              <Button
                className="reScanBtn"
                onClick={() => {
                  this.newScan();
                }}
              >
                SCANNER
              </Button>
            </p>
          </div>
        )}

        {/*!this.state.continuousScan && (
        <button
        className="newScan newScanON"
        onClick={(e) => {
          this.newScan(e);
        }}>
        new scan
        </button>
      )*/}

        {/*
        (configApp.continuousScan && !this.state.continuousScan && validate === 'off' && !showInfo) && (
          <button className="btnAutoScan" onClick={()=>{this.manageAutoScan()}}>attiva scansione automatica continua</button>
        )
      */}
      </>
    );
  }
}

export default withRouter(QrCodeReader);
